"use client";

import React from "react";
import { motion, useReducedMotion } from "framer-motion";
import { Link } from "@/components/common/Link";
export default function Manifesto() {
  const shouldReduceMotion = useReducedMotion();
  const animationVariants = {
    hidden: {
      opacity: 0,
      y: shouldReduceMotion ? 0 : 28
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: shouldReduceMotion ? 0.3 : 0.8,
        ease: [0.22, 1, 0.36, 1]
      }
    }
  };
  return <section id="brandmanifesto" data-nav="light" className="bg-background text-foreground py-24 sm:py-32 md:py-40 lg:py-48">
      <div className="mx-auto max-w-7xl px-6 sm:px-8 lg:px-12">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        amount: 0.3
      }} variants={animationVariants} className="max-w-4xl">
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold uppercase tracking-tight text-foreground leading-[1.08]">REFINED, TIMELESS AND BESPOKE RESIDENTIAL DESIGN BASED IN TENNESSEE</h2>

          <div className="mt-8 sm:mt-12">
            <Link to="/HomePage" className="group inline-flex items-center text-xs sm:text-sm uppercase tracking-[0.2em] font-medium text-foreground/80 hover:text-foreground transition-colors">
              <span className="mr-3 transition-transform duration-300 group-hover:translate-x-1">
                {"—"}
              </span>
              <span>More about us</span>
            </Link>
          </div>
        </motion.div>
      </div>
    </section>;
}